import { CMSDocument, PimProductDocument } from "@bmi/elasticsearch-types";
import React from "react";
import DocumentSimpleTableResults from "../../../components/DocumentSimpleTableResults";
import { DocumentTableHeader } from "../../../types/Document";
import groupBy from "../../../utils/groupBy";
import { AssetType } from "../types";
import DocumentCardsResults from "./DocumentCardsResults/DocumentCardsResults";
import DocumentTechnicalTableResults from "./DocumentTechnicalTableResults";

export type DocumentResultData = CMSDocument | PimProductDocument;

export type Format =
  | "simpleTable"
  | "simpleArchiveTable"
  | "technicalTable"
  | "cards";

type Props = {
  data: DocumentResultData[];
  assetTypes: readonly AssetType[];
  format: Format;
  pageNumber?: number;
};

const tableHeadersConfig: Record<
  "simpleTable" | "simpleArchiveTable",
  DocumentTableHeader[]
> = {
  simpleTable: ["add", "typeCode", "title", "size", "actions"],
  simpleArchiveTable: [
    "add",
    "title",
    "productStatus",
    "validityDate",
    "size",
    "actions"
  ]
};

const DocumentResults = ({
  data,
  assetTypes: contentfulAssetTypes,
  format,
  pageNumber
}: Props) => {
  if (format === "simpleTable" || format === "simpleArchiveTable") {
    const documentsByAssetTypeCode = groupBy(
      data,
      (document) => document.assetType.code
    );
    const documentAssetTypeCodes = Object.keys(documentsByAssetTypeCode);

    const commonAssetTypes = contentfulAssetTypes.filter((assetType) =>
      documentAssetTypeCodes.includes(assetType.code)
    );
    // eslint-disable-next-line security/detect-object-injection
    const tableHeaders = tableHeadersConfig[format].filter(
      (header) => !(commonAssetTypes.length < 2 && header.includes("type"))
    );
    return (
      <DocumentSimpleTableResults
        documents={data}
        headers={tableHeaders}
        pageNumber={pageNumber}
      />
    );
  }

  if (format === "technicalTable") {
    // TODO: Sort out the forced type cast
    return (
      <DocumentTechnicalTableResults
        documents={data as PimProductDocument[]}
        assetTypes={contentfulAssetTypes}
        pageNumber={pageNumber}
      />
    );
  }

  // TODO: Sort out the forced type cast
  return <DocumentCardsResults documents={data as CMSDocument[]} />;
};

export default DocumentResults;
